import { render, staticRenderFns } from "./AprovacaoItem.vue?vue&type=template&id=613bdeb3"
import script from "./AprovacaoItem.vue?vue&type=script&lang=js"
export * from "./AprovacaoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports